module.exports = __webpack_public_path__ + "img/icon-gd.d82cd4f6.png";